"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _react = _interopRequireDefault(require("react"));

var _Modal = _interopRequireDefault(require("angieslist-react-components/lib/Modal"));

var _urlCatalog = _interopRequireDefault(require("../../common/urlCatalog"));

require("./thimbleTransitionBanner.scss");

var _i, _img;

var thimbleIcon = require('./../assets/greenThimble.svg');

var ThimbleTransitionBanner = function ThimbleTransitionBanner() {
  return /*#__PURE__*/(0, _jsx2.default)(_Modal.default, {
    show: true,
    bsSize: "lg",
    id: "thimble-modal"
  }, void 0, /*#__PURE__*/(0, _jsx2.default)(_Modal.default.Body, {
    id: "thimble-modal--body"
  }, void 0, /*#__PURE__*/(0, _jsx2.default)("div", {
    id: "thimble-modal--logo-container",
    className: "text-center"
  }, void 0, /*#__PURE__*/(0, _jsx2.default)("img", {
    id: "thimble-modal--angi-bubble",
    src: _urlCatalog.default.media.angiLogoDenim(),
    alt: "Angi"
  }), _i || (_i = /*#__PURE__*/(0, _jsx2.default)("i", {
    className: "icon icon-right"
  })), _img || (_img = /*#__PURE__*/(0, _jsx2.default)("img", {
    src: thimbleIcon,
    alt: "Thimble"
  }))), /*#__PURE__*/(0, _jsx2.default)("p", {
    className: "text-center",
    style: {
      fontSize: '20px'
    }
  }, void 0, "Connecting you with Thimble to explore your options...")));
};

var _default = ThimbleTransitionBanner;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/thimbleTransitionBanner/thimbleTransitionBanner.js
// module id = 4032
// module chunks = 25